// Bài hướng dẫn trang Ca vận hành — /branch-shifts.
//
// Tách khỏi `hr.ts` vì bài chia theo NĂM thẻ nên dài gấp nhiều lần bài một
// trang thường, và người sửa bài này không phải cuộn qua chín bài nhân sự khác.
//
// Gom từ hai tệp cạnh bên theo CỤM VIỆC chứ không cắt cho đủ số dòng: hai thẻ
// của người đang làm ca, ba thẻ của người điều hành. Người sửa một thẻ mở đúng
// tệp có những thẻ liên quan nằm cạnh nhau.
//
// Phần cấp trang bên ngoài `tabs` vẫn giữ đủ: người không mở được thẻ nào vẫn
// đọc được trang này là gì.
//
// ⚠️ Ranh giới thông tin ở `../../types.ts` áp NGUYÊN VẸN. Chỗ nới duy nhất
// của kho là trang Cơ chế lương; đừng mượn nó vì thấy hộp giống nhau.

import type { GuideBook } from "../../types";
import { TAB_CA_HOM_NAY, TAB_SU_CO } from "./tabs-lam-ca";
import { TAB_TOAN_CHUOI, TAB_LICH_TUAN, TAB_MAU_PHU_CAP } from "./tabs-dieu-hanh";
import { TAB_DUYET_SO_MAT } from "./tab-duyet-so-mat";

export const BRANCH_SHIFT_GUIDES: GuideBook = {
  branch_shifts: {
    purpose: "Ca vận hành của cơ sở: bảng kiểm đầu ca, cuối ca và sổ sự cố trong ca.",
    // Thứ tự phải khớp thứ tự thẻ trên màn — bài kiểm đối chiếu. Hai cụm việc
    // xen kẽ nhau trên hàng thẻ, nên gom theo TÊN chứ không nối hai mảng: nối
    // mảng thì thứ tự bài lệch thứ tự màn.
    tabs: [TAB_CA_HOM_NAY, TAB_TOAN_CHUOI, TAB_LICH_TUAN, TAB_SU_CO, TAB_MAU_PHU_CAP, TAB_DUYET_SO_MAT],
    where: [
      'Các thẻ đầu trang: "Ca hôm nay", "Toàn chuỗi", "Lịch tuần", "Sự cố", "Mẫu & phụ cấp", "Duyệt số mặt".',
      "Số thẻ bạn thấy tuỳ theo công việc của bạn, nên hai người mở cùng trang có thể thấy khác nhau.",
    ],
    howItWorks: [
      "Ca chỉ chạy ở cơ sở đã bật ca vận hành; cơ sở chưa bật thì màn ghi rõ chứ không để trống.",
      "Một ca đi từ lúc được xếp người, tới lúc mở, tới lúc đóng — mỗi chặng nhìn thấy ở một thẻ khác nhau.",
      "Chuyện bất thường trong ca ghi vào sổ sự cố và sống tiếp cả sau khi ca đã đóng.",
    ],
    statuses: [
      { label: "Chờ mở", meaning: "Đã có người trực nhưng chưa ai bấm mở ca." },
      { label: "Đang mở", meaning: "Ca đang chạy." },
      { label: "Đã đóng", meaning: "Đã đóng ca và ghi xong báo cáo cuối ca." },
      { label: "Chưa xếp", meaning: "Hôm đó chưa ai được xếp trực ca này." },
      { label: "Chưa bật ca vận hành", meaning: "Cơ sở này chưa dùng tính năng ca." },
    ],
  },
};
